/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable unused-imports/no-unused-vars */
import React from 'react';

import Modal from '@/components/modal/modal';
import Typography from '@/components/typography/typography';
import Button from '@/components/button/button';
import Select from '@/components/select/select';

import {
	Box,
	DialogActions,
	DialogContent,
	DialogProps,
	DialogTitle,
	IconButton,
	MenuItem
} from '@mui/material';
import Close from '@mui/icons-material/Close';

import './company-selection-modal.scss';
import { IEmail } from '../utils/types';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

interface CompanySelectionModalProps {
	isOpen: boolean;
	setIsOpen: (value: IEmail | null) => void;
	modalProps?: DialogProps;
	email: IEmail;
	companies: Record<string, any>[];
	templateRoutes: Record<string, any>
}

const CompanySelectionModal: React.FC<CompanySelectionModalProps> = ({
	isOpen,
	setIsOpen,
	modalProps,
	companies,
	email,
	templateRoutes
}) => {

	const navigate = useNavigate();
	const [selectedCompany, setSelectedCompany] = React.useState<number>(0);

	const handleModalClose = () => {
		setIsOpen(null);
	};

	const handleContinue = () => {
		if(!selectedCompany) {
			enqueueSnackbar('Please select a company', { variant: 'error' });
			return;
		} else if(!email) {
			enqueueSnackbar('Something went wrong for a subject', { variant: 'error' });
			return;
		}

		navigate(templateRoutes.ADD_TEMPLATE(email._id), { state: { company_id: selectedCompany }})
	}

	return (
		<Modal
			open={isOpen}
			onClose={handleModalClose}
			maxWidth='xs'
			fullWidth
			{...modalProps}>
			<DialogTitle className='companySelectionModal--DialogTitle'>
				<Typography type='s3' color='inherit' weight='medium'>
					Select Company
				</Typography>
				<IconButton onClick={handleModalClose}>
					<Close fontSize='small' />
				</IconButton>
			</DialogTitle>
			<DialogContent className='companySelectionModal--DialogContents'>
				<Select
					displayEmpty
					value={selectedCompany}
					size='small'
					renderValue={(value) => value ? companies.find((option) => option.value === value)?.label : 'Select Company'}
					fullWidth
					sx={{
						bgcolor: 'white',
						borderRadius: 1,
						'& .MuiSelect-select': { py: 0.75 }
					}}
					onChange={(e) => {
						if (e.target.value) {
							setSelectedCompany(e.target.value as number);
						}
					}}>
					{companies.map((option) => (
						<MenuItem key={option.value} value={option.value}>
							<Typography type='s4' color='theme.secondary.1000'>{option.label}</Typography>
						</MenuItem>
					))}
				</Select>
			</DialogContent>
			<DialogActions className='companySelectionModal--DialogAction'>
				<Box display='flex' gap={1.5}>
					<Button className='companySelectionModal--DialogAction--WhiteBtn' onClick={handleModalClose}>Cancel</Button>
					<Button onClick={() => handleContinue()} disabled={!selectedCompany}>Continue</Button>
				</Box>
			</DialogActions>
		</Modal>
	);
};

export default CompanySelectionModal;
